import { API_URL } from "./config";
import { useEffect, useState } from "react";
import moment from "moment";
import _ from "lodash";
import token from "./Token";

import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { AiOutlinePlusCircle, AiFillSave, AiFillDelete, AiFillCheckCircle, AiOutlineClockCircle } from "react-icons/ai";

import "./HabitEdit.css";

function HabitEdit() {
  const [habits, setHabits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    document.title = "Edit Habits";
    if (localStorage.getItem("locked") == "true") {
      window.location.href = "/";
    }
    loadHabits();
  }, []);

  const loadHabits = async () => {
    setLoading(true);
    try {
      const res = await fetch(API_URL + "/habits?token=" + token);
      const data = await res.json();
      if (Array.isArray(data)) {
        const list = data.map(h => ({ ...h, __localId: h._id || getRandomId() }));
        setHabits(list);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getRandomId = () => Math.random().toString(36).slice(2, 10);

  const addHabit = () => {
    const nowIso = moment().toISOString();
    const blank = {
      __localId: "NEW_" + getRandomId(),
      name: "",
      description: "",
      count: 0,
      totalCount: 1,
      lastEvaluation: nowIso,
      nextEvaluation: "",
      evaluationFrequency: {
        type: "daily",
        dayOfWeek: [],
        dayOfMonth: [],
        hourOfDay: 6,
        minuteOfHour: 0
      },
      finish: 0,
      resetCountAtEvaluation: true,
      streak: [0,0,0,0,0,0,0],
      order: 0
    };
    setHabits([blank, ...habits]);
  };

  const updateHabitField = (h, field, value) => {
    const copy = _.cloneDeep(habits);
    const idx = copy.findIndex(x => x.__localId === h.__localId);
    copy[idx][field] = value;
    setHabits(copy);
  };

  const updateEvalField = (h, field, value) => {
    const copy = _.cloneDeep(habits);
    const idx = copy.findIndex(x => x.__localId === h.__localId);
    copy[idx].evaluationFrequency = copy[idx].evaluationFrequency || {};
    copy[idx].evaluationFrequency[field] = value;
    setHabits(copy);
  };

  const toggleDOW = (h, dow) => {
    const cur = h.evaluationFrequency.dayOfWeek || [];
    const next = cur.includes(dow) ? cur.filter(d => d !== dow) : [...cur, dow];
    next.sort((a, b) => a - b);
    updateEvalField(h, "dayOfWeek", next);
  };

  const parseDOM = (text) => {
    if (!text.trim()) return [];
    return Array.from(
      new Set(
        text.split(",").map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n) && n >= 1 && n <= 31)
      )
    ).sort((a, b) => a - b);
  };

  const setTimeHHMM = (h, hhmm) => {
    const [hh, mm] = (hhmm || "").split(":");
    const hour = parseInt(hh, 10);
    const minute = parseInt(mm, 10);
    setHabits((prev) => {
      const copy = _.cloneDeep(prev);
      const idx = copy.findIndex(x => x.__localId === h.__localId);
      if (idx === -1) return prev;
      copy[idx].evaluationFrequency = copy[idx].evaluationFrequency || {};
      if (!isNaN(hour)) copy[idx].evaluationFrequency.hourOfDay = hour;
      if (!isNaN(minute)) copy[idx].evaluationFrequency.minuteOfHour = minute;
      return copy;
    });
  };

  const hhmmOf = (h) => {
    const { hourOfDay = 6, minuteOfHour = 0 } = h.evaluationFrequency || {};
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(hourOfDay)}:${pad(minuteOfHour)}`;
  };

  const saveHabit = async (h) => {
    setSaving(true);
    try {
      const payload = { ...h };
      delete payload.__localId;
      const isNew = !payload._id;
      const url = isNew ? API_URL + "/newHabit?token=" + token
                        : API_URL + "/editHabit?token=" + token;
      const body = "data=" + encodeURIComponent(JSON.stringify(payload));
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body
      });
      await res.json();
      await loadHabits();
    } catch (e) {
      console.log(e);
    } finally {
      setSaving(false);
    }
  };

  const deleteHabit = async (h) => {
    if (!h._id) { 
      setHabits(habits.filter(x => x.__localId !== h.__localId)); 
      return; 
    }
    if (!window.confirm("Delete habit '" + h.name + "'?")) return;
    try {
      await fetch(API_URL + "/deleteHabit?token=" + token + "&id=" + h._id);
      await loadHabits();
    } catch (e) {
      console.log(e);
    }
  };

  const deferHabit = async (h) => {
    if (!h._id) return;
    try {
      await fetch(API_URL + "/deferHabit?token=" + token + "&id=" + h._id);
      await loadHabits();
    } catch (e) {
      console.log(e);
    }
  };

  const countHabit = async (h) => {
    if (!h._id) return;
    try {
      const res = await fetch(API_URL + "/countHabit?token=" + token + "&id=" + h._id);
      const data = await res.json();
      if (data && typeof data.reward !== "undefined") {
        alert("Reward: " + data.reward);
      }
      await loadHabits();
    } catch (e) {
      console.log(e);
    }
  };

  const renderStreak = (arr = []) => {
    const last7 = arr.slice(-7);
    return last7.map((v, i) => (v ? "✅" : "·")).join(" ");
  };

  return (
    <div className='AppRootDesktop'><div className='AppRootInnerOverlay'>
      <div className="habit-edit-page">
        <div className="action-bar">
          <h1>Edit Habits</h1>
          <Button variant="primary" onClick={addHabit}>
            <AiOutlinePlusCircle /> ADD NEW HABIT
          </Button>
        </div>
        
        {saving && <div className="text-center my-3"><Spinner animation='border' role='status' /> Saving...</div>}

        {loading ? (
          <div className="text-center" style={{ margin: 16 }}><Spinner animation='border' role='status' /></div>
        ) : (
          <Container maxWidth="lg">
            <Row>
              {habits.map(h => (
                <Col key={h.__localId} xs={12} lg={6}>
                  <div className="habit-card">
                  <div className="form-group habit-title">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Habit Name (e.g., Read a book)"
                      value={h.name || ""}
                      onChange={(e) => updateHabitField(h, "name", e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Description (optional)"
                      value={h.description || ""}
                      onChange={(e) => updateHabitField(h, "description", e.target.value)}
                    />
                  </div>
                  
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <label>Total Count</label>
                        <input
                          className="form-control"
                          type="number"
                          value={h.totalCount ?? 1}
                          onChange={(e) => updateHabitField(h, "totalCount", parseInt(e.target.value || "1", 10))}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                       <div className="form-group">
                          <label>Current</label>
                          <input className="form-control" disabled value={h.count ?? 0} />
                       </div>
                    </Col>
                  </Row>
                  
                  <Row>
                     <Col md={6}>
                        <div className="form-group">
                          <label>Finish Reward</label>
                          <input
                            className="form-control"
                            type="number"
                            value={h.finish ?? 0}
                            onChange={(e) => updateHabitField(h, "finish", parseInt(e.target.value || "0", 10))}
                          />
                        </div>
                     </Col>
                     <Col md={6} className="d-flex align-items-center">
                        <div className="form-group" style={{ marginBottom: 0 }}>
                          <Form.Check
                            type="switch"
                            id={`reset-toggle-${h.__localId}`}
                            label="Reset at evaluation"
                            checked={!!h.resetCountAtEvaluation}
                            onChange={(e) => updateHabitField(h, "resetCountAtEvaluation", e.target.checked)}
                          />
                        </div>
                     </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                       <div className="form-group">
                        <label>Frequency</label>
                        <select
                          className="form-select"
                          value={h.evaluationFrequency?.type || "daily"}
                          onChange={(e) => updateEvalField(h, "type", e.target.value)}
                        >
                          <option value="daily">Daily</option>
                          <option value="weekly">Weekly</option>
                          <option value="monthly">Monthly</option>
                        </select>
                      </div>
                    </Col>
                    <Col md={6}>
                       <div className="form-group">
                        <label>Time</label>
                        <input
                          className="form-control"
                          type="time"
                          value={hhmmOf(h)}
                          onChange={(e) => setTimeHHMM(h, e.target.value)}
                        />
                      </div>
                    </Col>
                  </Row>

                  {h.evaluationFrequency?.type === "weekly" && (
                    <div className="form-group dow-buttons">
                      <label>Days of Week</label>
                      <div>
                        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((d, i) => {
                          const active = (h.evaluationFrequency?.dayOfWeek || []).includes(i);
                          return (
                            <Button
                              key={d}
                              size="sm"
                              variant={active ? "primary" : "secondary"}
                              onClick={() => toggleDOW(h, i)}
                              style={{ marginRight: 6, marginBottom: 6 }}
                            >
                              {d}
                            </Button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {h.evaluationFrequency?.type === "monthly" && (
                    <div className="form-group">
                      <label>Days of Month (1–31, comma-separated)</label>
                      <input
                        className="form-control"
                        type="text"
                        value={(h.evaluationFrequency?.dayOfMonth || []).join(", ")}
                        onChange={(e) => updateEvalField(h, "dayOfMonth", parseDOM(e.target.value))}
                      />
                    </div>
                  )}

                  <div className="d-flex justify-content-between align-items-center mt-3">
                     <div className="next-evaluation">
                        Next: {h.nextEvaluation ? moment(h.nextEvaluation).format("YYYY-MM-DD HH:mm") : "n/a"}
                     </div>
                     <div className="streak-display" title="Last 7 days streak">
                       {renderStreak(h.streak)}
                     </div>
                  </div>

                  <Row className="button-group">
                    <Col xs={6} lg={3}>
                      <Button variant="success" onClick={() => saveHabit(h)} className="w-100">
                        <AiFillSave /> SAVE
                      </Button>
                    </Col>
                    <Col xs={6} lg={3}>
                      <Button variant="dark" onClick={() => countHabit(h)} className="w-100">
                        <AiFillCheckCircle /> DONE
                      </Button>
                    </Col>
                    <Col xs={6} lg={3}>
                      <Button variant="warning" onClick={() => deferHabit(h)} className="w-100">
                        DEFER
                      </Button>
                    </Col>
                    <Col xs={6} lg={3}>
                      <Button variant="danger" onClick={() => deleteHabit(h)} className="w-100">
                        <AiFillDelete /> DELETE
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
            </Row>
          </Container>
        )}
      </div>
    </div></div>
  );
}

export default HabitEdit;
